import * as angular from 'angular';
import * as _ from 'lodash';

import { ContextualField, ComponentDefinition, PropertyType, multiSelects } from '../../models';


class PropertyGridTableController implements angular.IComponentController {
    fields: ContextualField[];
    formController: angular.IFormController;
    item: { [modelName: string]: any };
    modernDesign: boolean;
    multiSelects: PropertyType[];

    static $inject = [];

    $onInit() {
        this.multiSelects = multiSelects;
    }

    isValid(field: ContextualField) {
        if (!!field.isValid) {
            const value = this.formController[field.propertyName].$viewValue;
            const result = field.isValid(value);
            for (const key of Object.keys(result)) {
                this.formController[field.propertyName].$setValidity(key, result[key]);
            }
        }
    }

    onChange() {
        return (field: ContextualField) => {
            if (this.formController) {
                this.isValid(field);
                if (field.onChange) {
                    const viewValue = this.formController[field.propertyName].$viewValue;
                    field.onChange(viewValue);
                }
            }
        };
    }

    //TOOD same as contextual control
    model(field: ContextualField) {
        if (field.extraData && field.extraData.subProperty) {
            const splittedProperty = field.extraData.subProperty.split('.');
            if (splittedProperty && splittedProperty.length >= 1) {
                let property: any = this.item;
                for (let i = 0; i < splittedProperty.length; i++) {
                    if (property[splittedProperty[i]]) {
                        property = property[splittedProperty[i]];
                    } else {
                        property = undefined;
                        break;
                    }
                }
                return property;
            }
        }
        return this.item;
    }
}

export const wtPropertyGridTable: ComponentDefinition = {
    componentId: 'wtPropertyGridTable',
    controller: PropertyGridTableController,
    template: require('./propertyGridTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        fields: '<',
        formController: '=',
        item: '<',
        modernDesign: '<'
    }
};
